import React from 'react';
import { TextField } from '@material-ui/core';

const styles = { 
    paddingBottom: '1rem',
}
export default function (props) {
    const { classes, ...other } = props;
    const newProps = {
        ...other,
        InputLabelProps: { shrink: true }
    };
    
    return (<TextField style={styles} {...newProps} />);
         
};